export { AdministrationDocumentSignataires } from "./administration-document-signataires";
